const testimonials = [
  {
    quote:
      "Eric is multi-talented and really industrious as it relates to growth. In my experience working with him he was able to manage a variety of unrelated projects, in many cases things he had limited experience with and really nail it. He's passionate, motivated, thoughtful and logical. I always knew I could count on him to get the job done and do it well. He'd be a tremendous asset to any organization looking to scale complex tasks.",
    name: "Arlen Marmel",
    initials: "AM",
    title: "GM",
    company: "Crunchyroll",
    linkedin: "https://www.linkedin.com/in/arlenmarmel/",
  },
  {
    quote:
      "Eric is a brilliant, honest, results-driven marketing and growth executive. He is metrics-based and rapidly generates quantifiable growth within budgets. He is a capable leader, effective communicator and top-notch in driving brand values concurrent with growth. He is able to work both as an IC and/or as part of a larger team and contribute hands-on excellence at all levels.",
    name: "Nick Desai",
    initials: "ND",
    title: "CEO & Co-Founder",
    company: "Renee",
    linkedin: "https://www.linkedin.com/in/nickdesaiai/",
  },
  {
    quote:
      "Eric embedded with our team and, within two weeks, uncovered critical gaps across our paid media, SEO, and attribution infrastructure that our agencies had missed for months. He brought rigor and accountability to our growth operations, immediately changing how we evaluated spend and vendor performance. He's the kind of operator who doesn't just identify problems — he builds the systems and scorecards to fix them. I'd work with him again without hesitation.",
    name: "Stefano Angeli",
    initials: "SA",
    title: "Founder & CEO",
    company: "Utoppia",
    linkedin: "https://www.linkedin.com/in/stefano-angeli/",
  },
  {
    quote:
      "Eric's practical growth thinking and analytical depth stood out immediately. He communicates with rare efficiency — no fluff, just clear recommendations backed by data. His flexible engagement model made him feel like a senior member of our team from day one. If you need someone who can diagnose what's working, cut what isn't, and build the systems to scale, Eric is that person.",
    name: "Michał Bortnik",
    initials: "MB",
    title: "Co-Founder & President",
    company: "Marco Polo",
    linkedin: "https://www.linkedin.com/in/bortnik/",
  },
  {
    quote:
      "We brought Eric in to assess and help lead a complex project involving technical, operational, and partnership challenges across multiple stakeholders. He got up to speed remarkably quickly, built trust across the organization, and was soon leading many of the conversations needed to move the work forward. Eric combines strong analytical thinking with a practical, get-things-done approach. He is resourceful, highly communicative, and comfortable operating in ambiguous environments where the path isn't immediately clear. Most importantly, he earned the confidence of our team by consistently bringing clarity, sound judgment, and viable solutions to difficult problems. I'd welcome the opportunity to work with Eric again.",
    name: "Tom McAlister",
    initials: "TM",
    title: "Chief Marketing Officer",
    company: "The WONDER Project",
    linkedin: "https://www.linkedin.com/in/tmcalister/",
  },
];

const TestimonialsSection = () => {
  return (
    <section id="testimonials" className="section-padding bg-secondary">
      <div className="content-max">
        <h2 className="font-headline text-3xl sm:text-4xl md:text-5xl text-foreground tracking-tight mb-12 md:mb-16">
          What Leaders Say
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-stretch">
          {testimonials.map((t, i) => (
            <a
              key={i}
              href={t.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-card border border-border rounded-xl p-7 md:p-9 flex flex-col transition-all duration-300 hover:border-primary/40 hover:shadow-[0_0_24px_-6px_hsl(var(--primary)/0.15)] hover:-translate-y-0.5 no-underline"
            >
              {/* Quotation mark */}
              <span className="font-headline text-5xl text-primary/30 leading-none select-none mb-4">
                &ldquo;
              </span>

              {/* Quote */}
              <p className="font-body text-base text-foreground/90 leading-relaxed flex-1">
                {t.quote}
              </p>

              {/* Attribution */}
              <div className="flex items-center gap-3 mt-8">
                <div className="w-10 h-10 rounded-full bg-primary/15 flex items-center justify-center shrink-0">
                  <span className="font-mono text-xs font-semibold text-primary">
                    {t.initials}
                  </span>
                </div>
                <div>
                  <p className="font-body text-sm font-semibold text-foreground">
                    {t.name}
                  </p>
                  <p className="font-body text-[11px] uppercase tracking-[0.12em] text-muted-foreground">
                    {t.title}, {t.company}
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;